import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useFeatureValue } from '@growthbook/growthbook-react';

const KEY = 'b8ff3157-2387-4358-a8c4-63c91d00af74';

export const AppsFlyerScript = () => {
  const smartBannerExperiment = useFeatureValue(
    'ab-web-multiple__smart-banner',
    'none'
  );
  if (smartBannerExperiment !== 'variant-1') {
    return null;
  }

  return (
    <Helmet>
      {/* bannerZIndex one less than the default z-index of the search DropdownInput modal */}
      <script>
        {`!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${KEY}"}});
        AF('banners', 'showBanner', {bannerZIndex: 9});`}
      </script>
    </Helmet>
  );
};
